/*  ==========================================================================
    ROOMS LIST VIEW V3
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

// filter function
function filter($filter,container,cat) {

    // show desired rooms
    $(container).find('.bn-room-box-v3').removeClass('bn-room-box-v3--act');
    $(container).find('.bn-room-box-v3--'+cat).addClass('bn-room-box-v3--act');

    // reposition rooms which are active
    $($(container).find('.bn-room-box-v3--act').get().reverse()).each(function() {
        $(this).prependTo(container);
    });

}

// hook function
function funcHook(container,data) {

    // calculate min price and add it to record
    utils.ehotelierPrices.initEhotelierRoomMinPrice(data);

}

// custom function
function funcCustom(container,data) {

    // filter
    let $filter = $(container).parents('.bn-rooms-list-view-v3').find('.bn-rooms-list-view-v3__tabs');
    if($filter.length) {

        // show rooms from first option on load
        let cat = $filter.find('.bn-button').first().attr('data-cat');
        $filter.find('.bn-button').first().addClass('bn-button--act');
        filter($filter,container,cat);

        // show filter options
        $filter.removeClass('hidden');

        // filtering by clicking on a option
        $filter.on('click', '.bn-button', function () {
            let cat = $(this).attr('data-cat');
            $filter.find('.bn-button').removeClass('bn-button--act');
            $(this).addClass('bn-button--act');
            filter($filter,container,cat);
        });

    }

}

// initialization
export function initRoomsListViewV3($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'room',
        subtype: 'list-view-v3'
    };

    // set category/ies
    if ($(container).attr('data-category')) {
        let category = $(container).attr('data-category');
        config.addParams.roomtypecategories = category;
    }

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initEhotlierService(config);
    });

    // details as pop up
    utils.ehotelierPopUp.initEhotelierPopUp(container,config);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/rooms-list-view-v3.js